"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function defineMessages(msgs) {
    return msgs;
}
exports.defineMessages = defineMessages;
var createFormattedComponent_1 = require("./components/createFormattedComponent");
var injectIntl_1 = require("./components/injectIntl");
exports.injectIntl = injectIntl_1.default;
exports.RawIntlProvider = injectIntl_1.Provider;
exports.IntlContext = injectIntl_1.Context;
var useIntl_1 = require("./components/useIntl");
exports.useIntl = useIntl_1.default;
var provider_1 = require("./components/provider");
exports.IntlProvider = provider_1.default;
exports.createIntl = provider_1.createIntl;
// IMPORTANT: Explicit here to prevent api-extractor from outputing `import('./types').CustomFormatConfig`
exports.FormattedDate = createFormattedComponent_1.createFormattedComponent('formatDate');
exports.FormattedTime = createFormattedComponent_1.createFormattedComponent('formatTime');
exports.FormattedNumber = createFormattedComponent_1.createFormattedComponent('formatNumber');
exports.FormattedList = createFormattedComponent_1.createFormattedComponent('formatList');
exports.FormattedDisplayName = createFormattedComponent_1.createFormattedComponent('formatDisplayName');
exports.FormattedDateParts = createFormattedComponent_1.createFormattedDateTimePartsComponent('formatDate');
exports.FormattedTimeParts = createFormattedComponent_1.createFormattedDateTimePartsComponent('formatTime');
var createFormattedComponent_2 = require("./components/createFormattedComponent");
exports.FormattedNumberParts = createFormattedComponent_2.FormattedNumberParts;
var relative_1 = require("./components/relative");
exports.FormattedRelativeTime = relative_1.default;
var plural_1 = require("./components/plural");
exports.FormattedPlural = plural_1.default;
var message_1 = require("./components/message");
exports.FormattedMessage = message_1.default;
var html_message_1 = require("./components/html-message");
exports.FormattedHTMLMessage = html_message_1.default;
var utils_1 = require("./utils");
exports.createIntlCache = utils_1.createIntlCache;
